import {
  customInstance
} from "./chunk-PXAHF6KP.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// generated/search-bff/controllers/geocoding/geocoding.ts
var fuzzyPoint = (fuzzyPointRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/geocode/fuzzy/point`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: fuzzyPointRequest
    },
    options
  );
};
var publicReverseGeocoding = (params, options) => {
  return customInstance(
    {
      url: `/api/v2/public/geocode/reverse`,
      method: "GET",
      params
    },
    options
  );
};
var publicForwardGeocoding = (params, options) => {
  return customInstance(
    {
      url: `/api/v2/public/geocode/forward`,
      method: "GET",
      params
    },
    options
  );
};

// src/services/getFuzzyPoint/getFuzzyPoint.ts
async function getFuzzyPoint(fuzzyPointRequest, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getFuzzyPoint");
    const data = await fuzzyPoint(fuzzyPointRequest, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  publicReverseGeocoding,
  publicForwardGeocoding,
  getFuzzyPoint
};
